export default __webpack_public_path__ + "static/media/gallery_05.68eeb9b8.jpg";